import { render } from "./SignatureComponent.vue?vue&type=template&id=d4b7d406&scoped=true&ts=true"
import script from "./SignatureComponent.vue?vue&type=script&lang=ts"
export * from "./SignatureComponent.vue?vue&type=script&lang=ts"

import "./SignatureComponent.vue?vue&type=style&index=0&id=d4b7d406&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b7d406"]])

export default __exports__